import { Slider } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useSliderValue } from "../../../../../hooks/useSliderValue";
import { Counter } from "../../../../Default/LekUI/Counter";

export const maxQuestionPerDay = 400;

function Progress(props) {
	const { t } = useTranslation();
	const { value, setValue, maxCount } = useSliderValue({
		value: props.questionsPerDay,
		setDetails: props.setDetails,
		length: props.queryLength,
		max: maxQuestionPerDay,
	});

	return (
		<div>
			<div className="flex justify-between items-end mb-8">
				<p className="m-0">{t("creators.courses.countOfQuestionsPerDay")}</p>
				<Counter count={value} unit={t("creators.courses.day")} />
			</div>
			<Slider
				defaultValue={20}
				max={maxCount}
				min={1}
				value={value}
				onChange={(_e, value) => setValue(value)}
				data-test-id="questions-per-day-slider"
			/>
			<span className="size-14-light text-grey">
				{t("creators.courses.tip")}
			</span>
		</div>
	);
}

export default Progress;
